var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "product_menu" } }, [
    _c("section", { staticClass: "menu-ctrl" }, [
      _c("span", { staticClass: "menu-ctrl__text" }, [
        _vm._v(_vm._s(_vm.$t("__map_obs.top_hint")) + "\n            "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.is_get_complete_webmap,
                expression: "!is_get_complete_webmap"
              }
            ]
          },
          [
            _c("v-progress-circular", {
              attrs: {
                indeterminate: "",
                size: "18",
                width: "2",
                color: "#2366f8"
              }
            }),
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("__map_obs.is_loading")) +
                "\n            "
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "icon-container" },
        [
          _c("QpeTooltip", {
            scopedSlots: _vm._u([
              {
                key: "hovered_item",
                fn: function() {
                  return [
                    _c(
                      "v-icon",
                      {
                        attrs: { color: "white" },
                        on: { click: _vm.close_all }
                      },
                      [
                        _vm._v(
                          "\n                        icon-unfold-less\n                    "
                        )
                      ]
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "tooltip_content",
                fn: function() {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("__map_obs.close_all_tree")))
                    ])
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("QpeTooltip", {
            scopedSlots: _vm._u([
              {
                key: "hovered_item",
                fn: function() {
                  return [
                    _c(
                      "v-icon",
                      {
                        attrs: { color: "white" },
                        on: { click: _vm.cancel_all }
                      },
                      [
                        _vm._v(
                          "\n                        icon-cancle-select                        \n                    "
                        )
                      ]
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "tooltip_content",
                fn: function() {
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.$t("__map_obs.cancel_all")))])
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "map-obs",
        class: { "eng-height": _vm.i18n_language === "en" },
        attrs: { id: "map_obs" }
      },
      [
        _vm.init_items.length > 0
          ? _c("TreeView", {
              ref: "child_treeview",
              attrs: {
                name: "map_obs",
                current_tab: "forecast_observation",
                init_items: _vm.init_items,
                checked_selectors: _vm.checked_selectors,
                init_opened_layers: [],
                check_function: _vm._cancel_timeless_items,
                special_list: _vm.special_list,
                selected_product_count_callback:
                  _vm.selected_product_count_callback,
                slider_ticks_mapping: _vm.slider_ticks_mapping
              },
              on: { control_special_list: _vm._control_special_checkboxes }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }